<template>
  <div v-if="mountStripeElement && mount">
    <div v-if="email">
      <div v-if="!userPaid" >        
        <div class="row">
          <div class="col-md-10 col-md-offset-1">
            <div class="form-group">
              <h5 class="text-center">Registration sucessful, a confirmation email was sent to {{ email }}</h5>
              <div v-if="this.$store.state.paymentFailedMotive != ''">
                <h5 class="text-center">But <b> {{ this.$store.state.paymentFailedMotive }} </b></h5>
              </div>
              <h5 class="text-center">Please provide your payment details</h5>
              <!-- Name -->
              <div class="group">
                <label for="cardHolderName">
                  <span>Name</span>
                  <input v-model="cardHolderName" id="card-name" class="field" placeholder="John Doe">
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-10 col-md-offset-1">
            <div class="form-group">
              <div class="group">
                <label for="card">
                  <span>Card</span>
                  <card-number class='stripe-element card-number field pt-10'
                    ref='cardNumber'
                    :stripe="publicKey"
                    :options="stripeOptions"
                    @change='number = $event.complete'
                  />
                </label>
              </div>
              <small id="card-errors" role="alert" v-text="errorMessage"></small>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-5 col-md-offset-1">
            <div class="form-group">
              <div class="group">
                <label for="card">
                  <span>Valid</span>
                  <card-expiry class='stripe-element card-expiry field pt-10'
                    ref='cardExpiry'
                    :stripe='publicKey'
                    :options='stripeOptions'
                    @change='expiry = $event.complete'
                  />
                </label>
              </div>
              <small id="card-errors" role="alert" v-text="errorMessage"></small>
            </div>
          </div>
          <div class="col-md-5">
            <div class="form-group">
              <div class="group">
                <label for="card">
                  <span>CVC</span>
                  <card-cvc class='stripe-element card-cvc field pt-10'
                    ref='cardCvc'
                    :stripe='publicKey'
                    :options='stripeOptions'
                    @change='cvc = $event.complete'
                  />
                </label>
              </div>
              <small id="card-errors" role="alert" v-text="errorMessage"></small>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-10 col-md-offset-1">
            <div class="form-group">
              <div class="group">
                <label for="cardZip">
                  <span>ZIP</span>
                  <input name="cardZip"
                    ref='cardZip'
                    class='field'
                    v-model="cardZip"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                    type="number"
                    maxlength="5"
                  />
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-10 col-md-offset-1">
            <small id="card-errors" role="alert" v-text="errorCardHolderName"></small>
          </div>
        </div>
        <br><br>
        <button :disabled="disabled" class="btn btn-info btn-fill btn-wd btn-submit f-right payment-button" @click="pay"><span> {{ buttonText }} </span></button>
      </div>
      <div v-else>
        <div class="col-md-10 col-md-offset-1">
            <div class="form-group">
              <h5 class="text-center">Your Payment Has Been Successfully Received.<br>Please check your email for confirmation!</h5>
              <h4 class="text-center">Thank you for your payment!</h4>
            </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="col-md-10 col-md-offset-1">
        <div class="form-group">
          <h5 class="text-center">We couldn't find your registration.</h5>
          <h4 class="text-center">Try again!</h4>
        </div>
      </div>
    </div>
  </div>
  <div v-else v-loading="!mount" class="loading"></div>
</template>

<script>
import axios from 'axios'
import swal from 'sweetalert2'
import { CardNumber, CardExpiry, CardCvc, createToken } from 'vue-stripe-elements-plus'
export default {
  components: {
    CardNumber,
    CardExpiry,
    CardCvc
  },
  data () {
    return {
      buttonText: 'Pay Now',
      errorCardHolderName: '',
      mountStripeElement: false,
      errorMessage: '',
      stripeOptions: {
        showIcon: true
      },
      cardHolderName: '',
      publicKey: process.env.STRIPE_PUBLIC_KEY,
      allowSitePayment: process.env.ALLOW_SITE_PAYMENT,
      paymentMethod: 'card',
      disabled: false,
      disclaimer: '',
      userPaid: false,
      email: '',
      mount: false,
      number: false,
      expiry: false,
      cvc: false,
      cardZip: '',
      complete: false
    }
  },
  beforeMount () {
    this.checkIfUserPaid()
  },
  mounted () {
    this.mountStripeElement = true
  },
  watch: {
    cardHolderName () {
      if (this.cardHolderName === '') {
        this.errorCardHolderName = 'Card Holder Name field cannot be empty'
      } else if (this.cardHolderName.length < 3) {
        this.errorCardHolderName = 'Card Holder Name field must be at least 5 characters'
      } else {
        this.errorCardHolderName = ''
      }
    },
    number () { this.update() },
    expiry () { this.update() },
    cvc () { this.update() }
  },
  methods: {
    update () {
      this.complete = this.number && this.expiry && this.cvc
      // field completed, find field to focus next
      if (this.number) {
        if (!this.expiry) {
          this.$refs.cardExpiry.focus()
        } else
        if (!this.cvc) {
          this.$refs.cardCvc.focus()
        } else {
          if (!this.cardZip) {
            this.$refs.cardZip.focus()
          }
        }
      } else if (this.expiry) {
        if (!this.cvc) {
          this.$refs.cardCvc.focus()
        } else if (!this.number) {
          this.$refs.cardNumber.focus()
        }
      }
      // no focus magic for the CVC field as it gets complete with three
      // numbers, but can also have four
    },
    async checkIfUserPaid () {
      await axios.post(process.env.SERVER_URI + '/check_if_paid', { confirmation_number: this.$route.params.id })
        .then((response) => {
          this.mount = true
          this.userPaid = response.data.paid
          this.disclaimer = response.data.disclaimer
          this.email = response.data.email
        }).catch(error => {
          console.log(error)
        })
    },
    errorHandler (event) {
      this.errorMessage = event.error ? event.error.message : ''
    },
    async pay () {
      if (this.cardHolderName && this.number && this.expiry && this.cvc && this.cardZip) {
        const result = await createToken({name: this.cardHolderName, address_zip: this.cardZip})
        if (result.token) {
          this.disabled = true
          this.buttonText = 'Submitting.. Please wait'
          await axios.post(process.env.SERVER_URI + '/payment', { stripeToken: result.token.id, email: this.$store.state.dataForInsurance.email, confirmation_number: this.$route.params.id })
          .then((response) => {
            const self = this
            if (response.data === true) {
              this.$store.state.paymentFailedMotive = ''
              swal('Completed!', 'Your Payment Has Been Successfully Received.<br>Please check your email for confirmation!', 'success')
              .then(function (result) {
                self.$router.push({ path: '/#' })
              })
            } else {
              swal('Error!', 'Something went wrong! <br> We could not process your payment! <br>' + response.data, 'error')
            }
          }).catch(error => {
            if (error.response.status === 403) {
              this.$store.state.paymentFailedMotive = ''
              swal('Error!', 'Something went wrong! <br> The registration was not completed or the payment has already been made!', 'error')
            } else {
              swal('Error!', 'Something went wrong! <br> We could not process your payment!', 'error')
            }
          })
          this.disabled = false
          this.buttonText = 'Pay Now'
        }
      } else {
        this.errorCardHolderName = 'Please fill in all the fields'
      }
    }
  }
}
</script>

<style scoped>
#card-errors{
  color: #31bebf;
}

.f-right{
  float: right;
}

.payment-button{
  background-color: white !important;
    color: #323737 !important;
    min-height: 40px;
    border: 2px solid #31bebf !important;
    border-radius: 20px;
}

.payment-button span:after {
  content: '\00bb';
  opacity: 1;
  font-size: 17px;
  margin-left: 5px;
}

span button {
    transition: 0.5s;
  }

.payment-button:hover{
  border: none;
  background-color: #31bebf !important;
  color: white !important;
  padding-right: 25px;
}

.payment-button:focus{
  border: none !important;
  background-color: #31bebf !important;
  color: white !important;
  padding-right: 25px;
}

.group {
    background: white;
    box-shadow: 0 7px 14px 0 rgba(49,49,93,0.10), 0 3px 6px 0 rgba(0,0,0,0.08);
    border-radius: 4px;
    border: 1px solid #9a9a9a;
}

label {
    position: relative;
    color: #31325F;
    font-weight: 300;
    height: 40px;
    line-height: 40px;
    margin-left: 20px;
    display: flex;
    flex-direction: row;
}

label > span {
    width: 80px;
    text-align: left;
}

.field {
    background: transparent;
    font-weight: 300;
    border: 0;
    color: #31325F;
    outline: none;
    flex: 1;
    padding-right: 10px;
    padding-left: 10px;
    cursor: text;
}

.pt-10{
  padding-top: 10px;
}

.radio-label{
  color: #474644;
  font-weight: bold;
  padding: 0;
  margin: 0;
}

.radio {
  margin: 0;
  margin-left: 10px;
}

.mt-6{
  margin-top: 6px;
}

.loading{
  margin-top: 30px;
  color: #31bebf;
}

>>> .el-loading-spinner .path {
  stroke: #31bebf !important;
}

@media screen and (max-width: 550px) {
  label > span {
    width: 40px;
    text-align: left;
    margin-right: 10px;
  }
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Homekit/Wizard/CardPage.vue